import './Footer.css'
import FooterInfoSection from "./FooterInfoSection";
import {ICity, IConstants, IFooter} from "../model/B2CInfo";
import {getMobileAppPromo} from "../../helpers/getMobileAppPromo";
import '../items/apppromo/AppPromoItem.css';

export interface IFooterProps {
    cities: ICity[]
    footer: IFooter
    city: ICity
    constants: IConstants
    mobile: boolean
    onSelected: (city: ICity) => void
}

export default function Footer(props: IFooterProps) {
    let cities = props.cities

    let infoItems = props.footer.info.map((section) => {
        return <FooterInfoSection mobile={props.mobile} section={section}/>
    })

    if (props.mobile) {
        let promo = getMobileAppPromo(props.constants)

        let citiesItems: Array<JSX.Element> = []
        cities.forEach((city, index) => {
            let className = city === props.city ? "Footer_city Footer_city_selected" : "Footer_city";
            citiesItems.push(
                <button key={city.name}
                        className={className}
                        onClick={(e) => props.onSelected(city)}>{city.name}
                </button>
            )
            if (index !== cities.length - 1) {
                if (index % 2 !== 0) {
                    citiesItems.push(<div style={{flexBasis: "100%"}}/>)
                } else {
                    citiesItems.push(<div key={`${city.name}dot`} className="Footer_city_dot"/>)
                }
            }
        });

        return <div className="Footer_mobile">
            <div className="Footer_cities_row_mobile">
                {citiesItems}
            </div>
            <div className="Footer_info_row_mobile">
                {infoItems}
            </div>
            <div className="Footer_info_section_download_app_title_mobile">
                Ещё раз скачайте драйв
            </div>
            <img alt={"Скачать приложение"}
                 src={promo.icon}
                 className="Footer_info_section_download_app_image_mobile"
                 onClick={(e) => window.open(promo.link, "_blank")}/>
        </div>
    } else {
        let citiesItems: Array<JSX.Element> = []
        cities.forEach((city, index) => {
            let className = city === props.city ? "Footer_city Footer_city_selected" : "Footer_city";
            citiesItems.push(
                <button key={city.name}
                        className={className}
                        onClick={(e) => props.onSelected(city)}>{city.name}
                </button>
            )
            if (index !== cities.length - 1) {
                citiesItems.push(<div key={`${city.name}dot`} className="Footer_city_dot"/>)
            }
        });

        return <div className="Footer">
            <div className="Section_container">
                <div className="Footer_cities_row">
                    {citiesItems}
                </div>
                <div className="Footer_info_row">
                    {infoItems}
                </div>
                <div className="Footer_info_section_download_app_title">
                    Ещё раз скачайте драйв
                </div>
                <div style={{marginBottom: "62px"}} className="App_promo_item_left_content_images_row">
                    <div className="App_promo_item_left_content_images_column">
                        <button
                            style={{backgroundImage: `url(${props.constants.app_store_icon})`}}
                            className="App_promo_item_left_content_image"
                            onClick={(e) => window.open(props.constants.app_store_link, "_blank")}
                        />
                        <button
                            style={{backgroundImage: `url(${props.constants.google_play_icon})`}}
                            className="App_promo_item_left_content_image"
                            onClick={(e) => window.open(props.constants.google_play_link, "_blank")}
                        />
                    </div>
                    <img src={props.constants.qr_code_icon} className="App_promo_item_left_content_qr_image"/>
                </div>
            </div>
        </div>
    }
}